module.exports = __webpack_public_path__ + "img/do-weryfikacji.83c746de.svg";